<template>
  <div
    class="carousel-container"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
  >
    <div
      class="carousel"
      :style="{
        transform: `translateY(${offset}px)`,
        transition: isTransitioning ? 'transform 0.8s ease' : 'none'
      }"
    >
      <div
        v-for="(item, index) in visibleItems"
        :key="index"
        class="tips"
        @click="handleView(item.type)"
      >
        <p class="left">
          <img :src="tips" alt="" />
          {{ item.title }}
        </p>
        <p class="right">
          查看
          <img :src="left" alt="" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    billFlag: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      left: require("../../../imgs/images/left.png"),
      tips: require("../../../imgs/images/tips.png"),
      items: [
        { title: "小鲲车服订单结算流程说明", type: "text" },
        { title: "重点税务公告", type: "toxic" },
        { title: "重要打款公告", type: "new" },
        { title: "小鲲车服订单结算流程说明", type: "text" }
      ],
      currentIndex: 0,
      interval: null,
      offset: 0,
      itemHeight: 0,
      isDragging: false,
      touchStartY: 0,
      isTransitioning: false,
      visibleItems: [],
      notrans: false
    };
  },
  mounted() {
    this.calculateItemHeight();
    this.initCarousel();
    this.startAutoPlay();
    window.addEventListener("resize", this.calculateItemHeight);
  },
  beforeDestroy() {
    this.stopAutoPlay();
    window.removeEventListener("resize", this.calculateItemHeight);
  },
  methods: {
    initCarousel() {
      // 创建三倍数据缓冲实现无缝循环
      this.visibleItems = [...this.items, ...this.items, ...this.items];
      this.currentIndex = this.items.length; // 初始位置在中间段
      this.$nextTick(this.calculateOffset);
    },
    handleView(type) {
      if (type === "text") {
        if (this.billFlag === 0) {
          tuhu.navigateTo({
            url: "/pages/home/text"
          });
        } else if (this.billFlag === 1) {
          tuhu.navigateTo({
            url: "/pages/home/textInvoice"
          });
        }
      } else if (type === "toxic") {
        // 重点税务公告：对应 noticeDialogs[1]（id=1）
        this.$emit("showSlide", 1);
      } else if (type === "new") {
        // 重要打款公告：对应 noticeDialogs[2]（id=2）
        this.$emit("showSlide", 2);
      }
    },
    calculateItemHeight() {
      this.$nextTick(() => {
        const tipEl = document.querySelector(".carousel-container");
        this.itemHeight = tipEl.offsetHeight || 72;
        this.calculateOffset();
      });
    },
    calculateOffset() {
      this.offset = -this.currentIndex * this.itemHeight;
    },
    next() {
      this.isTransitioning = true;
      this.currentIndex++;
      this.handleBoundaryCheck();
      this.calculateOffset();
    },
    prev() {
      this.isTransitioning = true;
      this.currentIndex--;
      this.handleBoundaryCheck();
      this.calculateOffset();
    },
    handleBoundaryCheck() {
      const total = this.items.length;
      // 向后滚动到缓冲区末尾时重置
      if (this.currentIndex >= total * 2) {
        this.isTransitioning = false;
        this.currentIndex = total;
        this.$nextTick(() => {
          this.calculateOffset();
        });
      }
      // 向前滚动到缓冲区起始时重置
      if (this.currentIndex < total) {
        this.isTransitioning = false;
        this.currentIndex = total * 2 - 1;
        this.$nextTick(() => {
          this.isTransitioning = true;
          this.calculateOffset();
        });
      }
    },
    goTo(index) {
      this.currentIndex = index % this.items.length;
      this.calculateOffset();
    },
    onTouchStart(e) {
      this.touchStartY = e.touches[0].clientY;
      this.isDragging = true;
      this.stopAutoPlay();
    },
    onTouchMove(e) {
      if (!this.isDragging) return;
      const touchCurrentY = e.touches[0].clientY;
      const diffY = touchCurrentY - this.touchStartY;
      this.offset = -this.currentIndex * this.itemHeight;
    },
    onTouchEnd(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      const touchEndY = e.changedTouches[0].clientY;
      const diffY = touchEndY - this.touchStartY;
      const threshold = 0;
      if (Math.abs(diffY) > threshold) {
        if (diffY < 0) this.next();
      } else {
        this.calculateOffset();
      }
      // 修正边界检查逻辑
      if (this.currentIndex >= this.items.length * 2) {
        this.goTo(0);
      } else if (this.currentIndex < 0) {
        this.goTo(this.items.length - 1);
      }
      this.startAutoPlay();
    },
    startAutoPlay() {
      this.stopAutoPlay();
      this.interval = setInterval(() => {
        if (this.currentIndex === 6) this.next();
        this.next();
        this.handleBoundaryCheck(); // 每次轮播后检查边界
      }, 2000);
    },
    stopAutoPlay() {
      clearInterval(this.interval);
    },
  }
};
</script>

<style scoped>
.carousel-container {
  position: relative;
  height: 3.2rem;
  overflow: hidden;
  touch-action: pan-y;
}
.carousel {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.tips {
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  height: 2rem;
  justify-content: space-between;
  background: rgba(254, 117, 120, 0.1);
  padding: 0.5rem;
  border-radius: 0.4rem;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
}
.left {
  display: flex;
  align-items: center;
  color: #ff1f24;
  font-size: 0.65rem;
}
.left img {
  width: 0.8rem;
  height: 0.8rem;
  margin-right: 0.2rem;
}
.right {
  color: #585f6d;
  font-size: 0.65rem;
  display: flex;
  align-items: center;
}
.right img {
  width: 0.7rem;
  height: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/slideTip.vue